import gql from 'graphql-tag';

export const mutationViewIntegration = gql`
  mutation viewIntegration (
    $id: DokkioID!
  ) {
    viewIntegration (
      id: $id
    )
  }
`;
export default mutationViewIntegration;
